/** admin/campaigns — KEYS. */
export const adminCampaignsKeys = {
  all: () => ['admin', 'campaigns'] as const,
  templates: () => [...adminCampaignsKeys.all(), 'templates'] as const,
  lists: () => [...adminCampaignsKeys.all(), 'list'] as const,
  detail: (id: string) => [...adminCampaignsKeys.all(), 'detail', id] as const,
};
